import { apiService } from './api';
import { setDisplayTimeZone } from '../utils/dateFormat';

const FALLBACK = { country: 'ZA', ianaTimeZoneId: 'Africa/Johannesburg' };

let loadPromise: Promise<{ country: string; ianaTimeZoneId: string }> | null = null;

/**
 * Loads country + IANA timezone from system settings (GET /System/date-locale) once per session,
 * and dedupes concurrent calls.
 */
export function loadDateLocaleFromSystem(): Promise<{ country: string; ianaTimeZoneId: string }> {
  if (!loadPromise) {
    loadPromise = apiService
      .get<{ country?: string; ianaTimeZoneId?: string }>('/System/date-locale')
      .then((res) => {
        const country = res.data?.country ?? FALLBACK.country;
        const ianaTimeZoneId = res.data?.ianaTimeZoneId ?? FALLBACK.ianaTimeZoneId;
        return { country, ianaTimeZoneId };
      })
      .catch(() => {
        return { ...FALLBACK };
      });
  }
  return loadPromise;
}

/**
 * Resolves on-screen timestamp timezone: personal preference, otherwise organisation IANA id.
 */
export async function applyResolvedDisplayTimeZone(
  preferredIanaTimeZoneId?: string | null,
): Promise<string> {
  const locale = await loadDateLocaleFromSystem();
  const resolved = preferredIanaTimeZoneId?.trim() || locale.ianaTimeZoneId;
  setDisplayTimeZone(resolved);
  return resolved;
}
